import { useIsEmployerUserVerified } from "@js/apps/common/hooks/is-employer-verified";

export const useCanShareWithTeamMembers = () => {
  return useIsEmployerUserVerified();
};
